<template>
    <Breadcrumb page-title="Configuration Knowledge Base Chat" page-section=""> </Breadcrumb>
    <section class="content">
      <div class="row">
          <div class="col-md-12">
          <!-- Custom Tabs -->
              <div class="row">
                  <div class="col-md-12">
                      <div class="box box-info">
                       <div class="box-header with-border">
                            <i class="fa fa-circle-o"></i>
                            <h3 class="box-title text-right"> Knowledge base Chat Configuration</h3>
                        </div>
                          <div class="box-body">
                             <div class="row">
   
                                <div class="col-md-6">
                                    <div class="form-group">
                                        
                                        <div><label class="control-label text-left">
                                        Description</label><textarea class="form-control"></textarea></div>
                                    </div>
                                    <div>
                                            <label class="switch">
                                            <Toggle/>
                                             <span class="mright-5"> Allow Chat with Agents </span>
                                            </label>
                                    </div>
                                    <div class="form-group">
                                        <div class="nested-panel-heading skill-heading">
                                            <h3 class="nested-title">Tools</h3>
                                        </div>
                                        <div>
                                            <label class="switch">
                                            
                                            <div class="toggle-container" tabindex="0" aria-checked="false" role="switch">
                                                 <Toggle/> Files
                                            </div>
                                           
                                            </label>
                                        </div>
                                    </div>
<div class="form-group">
                                <label class="col-md-12 control-label text-left"> 
                                    Vector StoreID
                                </label>
                                <div class="col-md-12">
                                    <div class="simple-label multiple">
                                     <div class="mbottom-15" v-for="(val, index) of optionparameter">
                                        <div class="float-btn-group">
                                            <button class="margin-5 icon-button button-delete" type="button" @click="removeValue(index)">
                                                    <i class="fa fa-times-circle"></i>
                                            </button>
                                            <input type="text" class="form-control">

                                           <button class="margin-5 icon-button button-add-row" type="button">       
                                             <i class="fa fa-plus-circle" @click="addValue"></i>
                                            </button>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>

                                    <!--v-if-->
                                   
                                    <div class="nested-panel-heading skill-heading">
                                        <h3 class="nested-title">Developers Instructions</h3>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label text-left mbottom-15"> This Instructions will be added to the prompt submitted into chatbot by the customer.<br></label>
                                        <textarea class="form-control"></textarea>
                                    </div>
                                    
                                    <div>
                                        <button  class="btn btn-primary">Save</button>
                                    </div>
                                   
                                </div>
                            </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4">
                  </div>
              </div>
          </div>
          <!-- /.col -->
      </div>
     
      <div class="expandedrowcontent box-bg-color" v-if="showDetails.showNew">
          <div class="box box-info with-border">
              <div class="box-body table-responsive">
                  <div class="box-header with-border">
                      <i class="fa fa-comments"></i>
                      <h3 class="box-title text-right">New Chat Configuration</h3>
                  </div>
                  <div class="box-body">
                    <ChatPanelSettings form-title="New Chats"></ChatPanelSettings>
                  </div>
              </div>
          </div>
      </div>
      <div class="row" v-if="showDetails.deleteChat">
          <div class="col-md-12" iservice-id-prefix="'Delete'">
              <div class="box box-danger" iservice-id="'Delete'">
                  <div class="box-header with-border">
                      <i class="fa fa-warning"></i>
                      <h3 class="box-title text-right">Delete Configuration</h3>
                  </div>
                  <div class="box-body">
                      <section class="box-content box-bg-color">
                      <div class="row">
                          <div class="form-horizontal">
                              <div class="col-md-12">
                                  <p class="text-danger">WARNING: Deletion is immediate and irrevocable.</p>
                              </div>
                          </div>
                          <div class="form-horizontal">
                              <div class="col-md-12"><button iservice-id="Confirm" class="btn btn-danger btn-sm">Confirm Deletion</button><button iservice-id="Cancel" class="btn btn-link" v-on:click="cancel()">Cancel</button></div>
                          </div>
                      </div>
                      </section>
                  </div>
              </div>
          </div>
      </div>
    
      <div  v-if="showDetails.showChatDetails">
          <div class="box box-info with-border">
              <div class="box-body table-responsive">
                  <div class="box-header with-border">
                      <i class="fa fa-comments"></i>
                      <h3 class="box-title text-right">Chat Configuration - Our Website</h3>
                  </div>
                  <div class="box-body">
                    <ChatPanelSettings form-title="Chats - Support issue"></ChatPanelSettings>
                  </div>
              </div>
          </div>
      </div>
  
    </section>
  </template>
  <style src="@vueform/toggle/themes/default.css"></style>
  <script>
  import Breadcrumb from '../components/Breadcrumb.vue';
  import MyInboxMessages from '../components/MyInboxMessages.vue';
  import InboxMessageDetail from '../components/InboxMessageDetail.vue';
  import iServiceSwitch from '../components/iServiceSwitch.vue';
  import ChatPanelSettings from '../components/ChatPanelSettings.vue';
  import Toggle from '@vueform/toggle'

  import Multiselect from '@vueform/multiselect'
  import Vue from 'vue';
  import { reactive,ref, onMounted } from 'vue'
  export default {
    name: 'MyMessageInboxComponents',
     components: {
      Breadcrumb,
      MyInboxMessages,
      InboxMessageDetail,
      iServiceSwitch,
      Multiselect,
      ChatPanelSettings,
      Toggle
    },
    data:function(){
      return{
        optionparameter : [1],
          searchlength : 1,
      }},
      methods: {
  addValue() {
      this.optionparameter.push('')
      this.searchlength = parseInt(this.searchlength) + 1;
   },
   removeValue(index) {
      if(this.optionparameter.length > 1){
       this.optionparameter.splice(index, 1);
       this.searchlength = parseInt(this.searchlength) - 1;
      }
    }
      },
    setup(){      
         
         var showDetails = reactive({showNew:false,deleteChat:false, showChatDetails:false,currentRow:''});
         var showNew =   reactive(false);
         var deleteChat =  reactive(false);
         var show = reactive(false);
         var currentRow = '';
  
         function showNewChat(){
           showDetails.showNew = true; 
           showDetails.deleteChat = false;  
           showDetails.showChatDetails = false;
           showDetails.active_el = '';
         }
         function showDeleteChat(){
           showDetails.showNew = false; 
           showDetails.deleteChat = true;  
         }
         function showMessageDetails(val,row){
           showDetails.showNew = false; 
           showDetails.deleteChat = false;  
           showDetails.showChatDetails=true;
           showDetails.active_el = row;
         }
         function cancel(){
           showDetails.showNew = false; 
           showDetails.deleteChat = false;  
           showDetails.showChatDetails=false;
         }
         
  
         return{cancel,showNew,deleteChat,showDetails,showNewChat,showDeleteChat,showMessageDetails};
    }
  
  }
  </script>
  